import { render, staticRenderFns } from "./WordRecognition.vue?vue&type=template&id=114fefcc&scoped=true&"
import script from "./WordRecognition.vue?vue&type=script&lang=js&"
export * from "./WordRecognition.vue?vue&type=script&lang=js&"
import style0 from "./WordRecognition.vue?vue&type=style&index=0&id=114fefcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114fefcc",
  null
  
)

export default component.exports